// Team role permission matrix — referenced everywhere via can(role, perm).
// Hidden is better than locked: if can() returns false, do not render that UI.

export type TeamRole = "owner" | "manager" | "staff";

export type PermissionKey =
  | "accessLeads"
  | "viewAllLeads"
  | "updateAnyLead"
  | "viewAnalytics"
  | "viewStaffReport"
  | "manageBilling"
  | "manageTeam"
  | "configureFilters"
  | "viewHipaaSettings"
  | "viewChatbotEmbed"
  | "viewPipelineValue"
  | "viewReferralOutreach"
  | "sendOutreachEmails"
  | "viewAssignedOnly"
  | "viewTaskView"
  | "viewGrowthMarketing";

export const PERMISSIONS: Record<TeamRole, Record<PermissionKey, boolean>> = {
  owner: {
    accessLeads: true,
    viewAllLeads: true,
    updateAnyLead: true,
    viewAnalytics: true,
    viewStaffReport: true,
    manageBilling: true,
    manageTeam: true,
    configureFilters: true,
    viewHipaaSettings: true,
    viewChatbotEmbed: true,
    viewPipelineValue: true,
    viewReferralOutreach: true,
    sendOutreachEmails: true,
    viewAssignedOnly: false,
    viewTaskView: false,
    viewGrowthMarketing: true,
  },
  manager: {
    accessLeads: true,
    viewAllLeads: true,
    updateAnyLead: true,
    viewAnalytics: false,
    viewStaffReport: false,
    manageBilling: false,
    manageTeam: false,
    configureFilters: false,
    viewHipaaSettings: false,
    viewChatbotEmbed: false,
    viewPipelineValue: false,
    viewReferralOutreach: true,
    sendOutreachEmails: true,
    viewAssignedOnly: false,
    viewTaskView: false,
    viewGrowthMarketing: false,
  },
  staff: {
    accessLeads: true,
    viewAllLeads: false,
    updateAnyLead: false,
    viewAnalytics: false,
    viewStaffReport: false,
    manageBilling: false,
    manageTeam: false,
    configureFilters: false,
    viewHipaaSettings: false,
    viewChatbotEmbed: false,
    viewPipelineValue: false,
    viewReferralOutreach: false,
    sendOutreachEmails: false,
    viewAssignedOnly: true,
    viewTaskView: true,
    viewGrowthMarketing: false,
  },
};

export function can(role: TeamRole | null | undefined, permission: PermissionKey): boolean {
  if (!role) return false;
  return PERMISSIONS[role]?.[permission] ?? false;
}
